<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Evidenza home', route: '/backoffice/home-evidenza' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formHome" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <h2>Contenuto</h2>
            <span class="ac-meta">personalizzato in home page</span>
        </div>

        <p-checkbox label="Usa contenuto personalizzato" formControlName="attivo" value="attivo" pTooltip="Se deselezionato, verrà mostrato lo spettacolo in evidenza oppure il video di default" tooltipPosition="top" />

        <ng-container *ngIf="isAttivo">
            <div class="fld">
                <label>* Tipo contenuto</label>
                <p-dropdown [options]="tipi" optionLabel="label" optionValue="value" placeholder="Seleziona il tipo di contenuto" formControlName="tipo" styleClass="w-full" appendTo="body"></p-dropdown>
            </div>

            <div *ngIf="isVideo">
                <app-file-upload [form]="formHome" [control]="'video'" [label]="'Video'" [multiple]="false" [accept]="'video/*,.mp4,.mov'" [text]="'Seleziona un video'"></app-file-upload>
                <small class="block mt-2" style="color: var(--acc-ink-mute)">Il video verrà riprodotto in loop con pulsante per attivare l'audio.</small>
            </div>

            <ng-container *ngIf="isImmagine">
                <app-file-upload [form]="formHome" [control]="'immagine'" [label]="'Immagine'" [multiple]="false" [accept]="'image/*'" [text]="'Seleziona un\'immagine'"></app-file-upload>
                <div class="fld">
                    <label>Testo</label>
                    <p-editor [style]="{ height: '150px' }" formControlName="testo" />
                </div>
            </ng-container>

            <div class="ac-section-head mt-2">
                <h2>Pulsante</h2>
            </div>

            <div class="fld">
                <label>Testo pulsante</label>
                <input type="text" pInputText class="w-full" placeholder="Testo pulsante" formControlName="testo_link" />
            </div>
            <div class="fld">
                <label>Azione pulsante</label>
                <p-dropdown [options]="tipiPulsante" optionLabel="label" optionValue="value" placeholder="Seleziona l'azione del pulsante" formControlName="tipo_pulsante" styleClass="w-full" appendTo="body"></p-dropdown>
            </div>
            <div class="fld" *ngIf="isPulsanteLink">
                <label>Link</label>
                <input type="text" pInputText class="w-full" placeholder="https://..." formControlName="link" />
            </div>
            <div *ngIf="isPulsanteFile">
                <app-file-upload [form]="formHome" [control]="'file'" [label]="'File da scaricare'" [multiple]="false" [accept]="'application/pdf,.doc,.docx'" [text]="'Seleziona un file'"></app-file-upload>
            </div>
        </ng-container>

        <div class="acc-actions">
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formHome.valid">Salva modifiche</button>
        </div>
    </form>
</section>
